export default __webpack_public_path__ + "media/cloud-diagram.32578f10.png";